import { useCallback, useEffect, useState } from "react";
import { Basket, ArrowSquareOut, Check } from "@phosphor-icons/react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const oops = (e) => toast.error(formatApiErrorDetail(e?.response?.data?.detail));

export const GroceryRun = () => {
  const [data, setData] = useState(null);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    api.get("/cafeteria/grocery-run").then(({ data: d }) => setData(d)).catch(oops);
  }, []);
  useEffect(() => { load(); }, [load]);

  const add = async () => {
    setBusy(true);
    try {
      await api.post("/cafeteria/grocery-run", { name });
      setName("");
      load();
    } catch (e) { oops(e); } finally { setBusy(false); }
  };

  const tick = async (id) => {
    try {
      await api.post(`/cafeteria/grocery-run/${id}/done`);
      toast.success("Ticked off");
      load();
    } catch (e) { oops(e); }
  };

  if (!data) return <p className="py-8 text-center text-sm text-slate-500">Loading the grocery run…</p>;

  return (
    <div className="space-y-4" data-testid="grocery-run">
      <div className="border border-border bg-white p-4">
        <p className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#0F172A]">
          <Basket size={15} /> Canteen grocery run
        </p>
        <p className="mt-1 text-xs text-slate-600">
          What the counter needs. Each line opens Instacart with that item searched, ready to add to your basket.
          {data.seeded ? " This is the starting list — add your own and it replaces it." : ""}
        </p>
        <div className="mt-3 flex flex-wrap items-end gap-2">
          <Input data-testid="grocery-add-name" className="w-full sm:w-72" placeholder="Milk, 4 pints"
            value={name} onChange={(e) => setName(e.target.value)} />
          <Button data-testid="grocery-add" onClick={add} disabled={busy || name.trim().length < 2}>
            Add to the run
          </Button>
          <a href={data.basket_url} target="_blank" rel="noreferrer" data-testid="grocery-open-instacart"
            className="tap-safe inline-flex items-center gap-1.5 border border-border px-3 py-2 text-xs font-semibold text-slate-600 hover:border-[#002FA7] hover:text-[#002FA7]">
            <ArrowSquareOut size={14} /> Open Instacart
          </a>
        </div>
      </div>

      <div className="border border-border bg-white p-4">
        <ul className="space-y-2" data-testid="grocery-lines">
          {data.lines.map((l, i) => (
            <li key={l.name} data-testid={`grocery-line-${i}`}
              className="flex flex-wrap items-center justify-between gap-2 border-b border-border pb-2 text-sm text-slate-700 last:border-0 last:pb-0">
              <span>{l.name}</span>
              <span className="flex items-center gap-2">
                <a href={l.url} target="_blank" rel="noreferrer" data-testid={`grocery-buy-${i}`}
                  className="tap-safe inline-flex items-center gap-1.5 border border-border px-2.5 py-1.5 text-xs font-semibold text-slate-600 hover:border-[#002FA7] hover:text-[#002FA7]">
                  <ArrowSquareOut size={12} /> Instacart
                </a>
                {l.id && (
                  <button onClick={() => tick(l.id)} data-testid={`grocery-done-${i}`}
                    className="tap-safe inline-flex items-center gap-1.5 border border-border px-2.5 py-1.5 text-xs font-semibold text-slate-600 hover:border-[#0F7A3D] hover:text-[#0B5C2E]">
                    <Check size={12} /> Got it
                  </button>
                )}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
